export default "__VITE_ASSET__BHRZAFWV__"